<div class="content-body-wrapper general-setting mb-3">
  <div class="content-body-title">
    <div class="header-text d-flex justify-space-between align-items-center">
      <div>
        <p><span>Email Template</span></p>
      </div>
      <button
        mat-button
        class="header-text-close d-flex align-items-center"
        disableRipple
        (click)="closeClick()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="content-body">
    <div>
      <div class="accordion-toggle">
        <mat-icon
          (click)="toggleAccordion(); accordion.openAll()"
          *ngIf="isExpandAll"
        >
          keyboard_double_arrow_down
        </mat-icon>
        <mat-icon
          (click)="toggleAccordion(); accordion.closeAll()"
          *ngIf="!isExpandAll"
        >
          keyboard_double_arrow_up
        </mat-icon>
      </div>
      <mat-accordion [multi]="true">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="d-flex flex-column">
                <span>CT600 form and Computation</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="content-body">
            <div class="template-layout">
              <form [formGroup]="emailForm" class="editor-column">
                <div class="form-field fund-name">
                  <p>Subject</p>
                  <mat-form-field class="w-650 subject-field">
                    <input
                      matInput
                      formControlName="subject"
                      autocomplete="off"
                    />
                  </mat-form-field>
                </div>
                <div class="form-field w-650 content-field">
                  <p>Contents</p>
                  <angular-editor
                    formControlName="messageBody"
                    [config]="editorConfig"
                  ></angular-editor>
                </div>
              </form>

              <aside class="tag-panel" aria-label="Capium Tags">
                <div class="tag-panel__title">Capium Tags</div>
                <div class="tag-groups">
                  <div class="tag-group" *ngFor="let group of tagGroups">
                    <button
                      type="button"
                      class="tag-group__header"
                      (click)="toggleTagGroup(group)"
                    >
                      <mat-icon class="tag-group__toggle">
                        {{ group.expanded ? 'arrow_drop_down' : 'arrow_right' }}
                      </mat-icon>
                      <mat-icon class="tag-group__folder">folder</mat-icon>
                      <span>{{ group.label }}</span>
                    </button>

                    <div class="tag-group__items" *ngIf="group.expanded">
                      <button
                        type="button"
                        class="tag-item"
                        *ngFor="let tag of group.tags"
                        (mousedown)="preserveEditorSelection($event)"
                        (dblclick)="insertTag(tag.token)"
                        [attr.aria-label]="'Insert ' + tag.label"
                      >
                        <mat-icon class="tag-item__icon">description</mat-icon>
                        <span>{{ tag.label }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <p class="tag-panel__hint">* double click to add tag</p>
              </aside>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<div class="action-wrapper button-action-wrapper wp-100">
  <div class="content-body">
    <button
      class="action-button primary-button mr-1"
      type="button"
      mat-button
      disableRipple
      (click)="saveEmailTemplate()"
    >
      Save
    </button>
    <button
      class="action-button secondary-button mr-1"
      type="button"
      mat-button
      disableRipple
      (click)="resetForm()"
    >
      Cancel Changes
    </button>
  </div>
</div>
<app-custom-notifications></app-custom-notifications>
